import { FeedbackType } from '@/api/gql/graphql';
import {
  useCreateFeedback,
  useFindFeedbacks,
} from '@/api/hooks/useFeedbackGenerate';
import { useToast } from '@/hooks/useToast';
import { useState } from 'react';

export const useFeedback = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [feedbackText, setFeedbackText] = useState('');

  const { mutate: createFeedback, isPending: isLoadingCreateFeedback } =
    useCreateFeedback();
  const { data: feedbacks, isLoading: isLoadingFeedbacks } = useFindFeedbacks(
    {},
  );
  const { showToast } = useToast();

  const handleCreateFeedback = (e: React.FormEvent) => {
    e.preventDefault();
    createFeedback(
      {
        category:
          selectedCategory as (typeof FeedbackType)[keyof typeof FeedbackType],
        feedbacks: [feedbackText],
      },
      {
        onSuccess: () => {
          showToast('Feedback créé avec succès', 'success');
          setFeedbackText('');
          setSelectedCategory(null);
        },
        onError: () => {
          showToast('Erreur lors de la création du feedback', 'error');
        },
      },
    );
  };

  return {
    handleCreateFeedback,
    isLoadingCreateFeedback,
    FeedbackType,
    selectedCategory,
    setSelectedCategory,
    feedbackText,
    setFeedbackText,
    feedbacks,
    isLoadingFeedbacks,
  };
};
